import { IItemPurchase } from '@reaffiliates/typescript';
import { getRegion } from '@utils/misc';
import { getCurrencyByRegion } from '@utils/formatPrice';
import { IProductObject } from '@features/categories/typescript';
const CreateProductItems = (products: IProductObject[] | IProductObject, category: string, priceListName: string) => {
  const items: Array<IItemPurchase> = [];
  const region = getRegion();
  const currency = getCurrencyByRegion(region);
  const removeCurrencySymbol = currency === 'MXN' ? [2] : [0, -2];
  const prepareProducts = Array.isArray(products) ? [...products] : [products];
  prepareProducts.forEach((product: IProductObject) => {
    if (product?.id) {
      const price = Number(product.getPrice(priceListName).slice(...removeCurrencySymbol).replace(/\s/g, '').replace(',', '.'));
      items.push({
        item_name: product.name,
        item_id: product.id.toString(),
        currency,
        price,
        item_category: category
      });
    }
  });
  return items;
};
export default CreateProductItems;